import * as React from 'react'
import styled from 'styled-components'
import I18n from '../../../../core/i18n'
import { IJsonResponse } from '../../../../core/JsonApiSerializer'
import { agentService, utilService } from '../../../../core/services'
import * as interfaces from '../../../../static/interfaces'
import * as Hooks from '../../../../utils/hooks'
import { Button } from '../../../atoms'
import { EditTable } from '../../../organisms'
import { Panel } from '../../../atoms'
import SidebarLayout from '../../_layouts/sidebarLayout'

declare var window: interfaces.IWindow

interface IProps {
  tasks: {
    tasks: IJsonResponse
  }
  user: any
}

const COLUMNS = [
  {
    name: I18n.t('generic.name'),
    field: 'name',
    required: true,
  },
  {
    name: I18n.t('generic.label'),
    field: 'label',
    required: true,
  },
  {
    name: I18n.t('generic.position'),
    field: 'position',
    required: false,
  },
]

const TasksIndex: React.FC<IProps> = props => {
  Hooks.SetDocumentTitle('Agent tasks')
  const { data, pagination } = agentService.getDataFromJson(props.tasks.tasks)
  const { data: userData } = utilService.getDataFromJson(props.user)

  const [tasks, setTasks] = React.useState(data)
  const handleDelete = React.useCallback(
    async id => {
      const response = await agentService.deleteTask(id)
      // TODO 成功レスポンスと揃えたい
      window.flashMessages.addMessage({
        text: response.data.flush.message,
        type: response.data.flush.type,
      })
      setTasks(tasks.filter(skill => skill.id !== id))
    },
    [tasks]
  )

  return (
    <SidebarLayout user={userData}>
      <Wrapper>
        <Panel
          title={
            <Heading>
              <span>{I18n.t('generic.tasks')}</span>
              <Button small={true}>
                <a href="/agent/tasks/new">{I18n.t('generic.create_new')}</a>
              </Button>
            </Heading>
          }
        >
          <EditTable
            editable={true}
            columns={COLUMNS}
            records={tasks}
            pagination={pagination}
            handleDelete={handleDelete}
            getEditLink={({ id }) => `/agent/tasks/${id}/edit`}
          />
        </Panel>
      </Wrapper>
    </SidebarLayout>
  )
}

const Wrapper = styled.div`
  width: 100%;
  padding: 22px 40px 80px 46px;

  .Panel {
    max-width: none;
  }
`

const Heading = styled.div`
  .Button {
    margin-left: 12px;
  }
`

export default TasksIndex
